var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCarbonIntensityModerateIcon = function SvgCarbonIntensityModerateIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 95,
    viewBox: "0 0 63 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8701 95L52.272 69L45.6738 43H13.3257L0.129395 95H58.8701Z",
    fill: "#E7A234"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.8168,
    cy: 30.4636,
    r: 7,
    transform: "rotate(-7.14918 29.8168 30.4636)",
    fill: "#E7A234",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.9346,
    cy: 14.1439,
    r: 12.5,
    transform: "rotate(-7.14918 48.9346 14.1439)",
    fill: "#E7A234",
    fillOpacity: 0.3
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCarbonIntensityModerateIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "carbon_intensity_moderate_icon.c22b4e03db0c0d83b2427255848644ce.svg";